import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicSummary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Summary"
      takeaways={[
        { text: "Only theory questions are possible from this module." },
        { text: "IAS architecture may include coding questions along with its architecture." },
        { text: "Only 4-5 theory questions are expected from this module." },
        { text: "One of the common difference-based questions will appear (CISC vs RISC or Harvard vs Von Neumann)." },
      ]}
      videos={[]} // No videos for summary
      questions={[]} // No specific questions for summary
      exampleVideos={[]} // No example videos for summary
    />
);
}

export default ModuleSubtopicSummary;
